import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Interface for the Dashboard
interface IDashboardState {
	subPage: string
}

// Initial state
const initialState: IDashboardState = {
	subPage: ''
}

// Slice definition
export const dashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {
		setSubPage: (state, action: PayloadAction<string>) => {
			state.subPage = action.payload
		}
	}
})

// Export actions
export const { setSubPage } = dashboardSlice.actions

// Export selectors
export const subPage = (state: RootState) => state.dashboard.subPage

// Export the reducer
export default dashboardSlice.reducer
